import {Injectable} from '@angular/core';
import {BrowserXhr} from '@angular/http';

@Injectable()
 /**
 * Extending the BrowserXhr to support CORS
 */
export class CustExtBrowserXhr extends BrowserXhr {
  constructor() {
      super();
  }
  build(): any {
    const xhr = super.build();
    xhr.withCredentials = false;
    return <any>(xhr);
  }
}
